module.exports = __webpack_public_path__ + "assets/img/hbjh23.08ab8594.png";